

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Form, Input } from 'antd';
import { forgot } from '@share/store/slices';

import img from '@assets/images/element/congratulations.svg';

import './style.scss';

export function ForgotPassword() {
  const dispatch = useDispatch();

  const onFinish = (values: any) => {
    dispatch(forgot(values.email));
  };
  
  return (
    <section className="log-in">
      <div className="container h-100 d-flex px-3 px-md-4 py-3 py-md-0">
        <div className="row justify-content-center align-items-center m-auto" style={{ width: '100%' }}>
          <div className="col-12">
            <div className="bg-mode shadow rounded-3 overflow-hidden">
              <div className="row g-0">
                <div className="col-lg-6 d-flex align-items-center order-2 order-lg-1">
                  <div className="p-3 p-lg-5">
                    <img src={img} alt="Login Side" />
                  </div>
                  <div className="vr opacity-1 d-none d-lg-block"></div>
                </div>

                <div className="col-lg-6 order-1">
                  <div className="p-sm-4 p-3 p-sm-7">
                    <h1 className="mb-2 h3"><FormattedMessage id="forgot.password" /></h1>

                    <Form
                      name="normal_password"
                      className="password-form"
                      layout="vertical"
                      onFinish={onFinish}
                    >
                      <Form.Item
                        name="email"
                        label="E-mail"
                        rules={[
                          { type: 'email', message: <FormattedMessage id="the.input.is.not.valid.email" /> },
                          { required: true, message: <FormattedMessage id="please.input.your.email" /> },
                        ]}
                      >
                        <Input placeholder="Email" />
                      </Form.Item>

                      <Form.Item>
                        <button type="submit" className="btn btn-primary w-100 mb-3 mx-0">
                          <FormattedMessage id="send.email" />
                        </button>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
